module.exports = __webpack_public_path__ + "img/infinite scroll.6e87ba4e.png";